
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Picnicspotnearwashish() {



  const cardData =
  {
    keyword: ' Picnic Spot Near Washim',
    heading:  'Woodland Escape: Picnic Spot Near Washim ',
    headingDescription: 'Woodland Escape Resort is a great picnic spot near Washim, offering a peaceful retreat into nature with green lawns, forest-edged picnic zones, and comfortable amenities. Just a short drive from Washim, the resort invites families and friends to relax outdoors, spread out on the lawn, engage in light games or nature walks, and enjoy a well-prepared picnic meal in a tranquil setting. With clean surroundings, courteous staff, and a calm ambience away from city hustle, Woodland Escape Resort near Washim turns an ordinary outing into a refreshing and memorable picnic experience.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Picnic Spot Near Washim",
      "description": "Discover the best picnic spots near Washim offering serene landscapes, lush greenery, and peaceful surroundings perfect for a day out with family or friends. These locations provide opportunities for relaxation, photography, and recreational activities while being easily accessible from the city."
    },
    {
      "name": "Washim Top Picnic Places",
      "description": "Explore the top picnic places in Washim featuring scenic gardens, riversides, and hills. Ideal for both nature lovers and casual visitors, these spots offer facilities like seating areas, walking trails, and picnic zones to ensure a fun and enjoyable day outdoors."
    },
    {
      "name": "Washim Family Picnic Spot",
      "description": "Plan a family-friendly picnic in Washim with spots suitable for all ages. From kids’ play areas to shaded seating and open lawns for games, these picnic locations provide a safe, comfortable, and entertaining environment for family bonding."
    },
    {
      "name": "Washim Nature Picnic Spot",
      "description": "Reconnect with nature at Washim’s beautiful nature picnic spots, surrounded by forests, rivers, and hills. Enjoy fresh air, birdwatching, and peaceful trails while having a perfect day outdoors immersed in the natural beauty of the region."
    },
    {
      "name": "Affordable Picnic Spot Washim",
      "description": "Enjoy budget-friendly picnic spots in Washim that offer scenic beauty, accessibility, and essential amenities without compromising on comfort. These locations are perfect for those looking for a relaxing outdoor experience without spending too much."
    },
    {
      "name": "Washim Weekend Picnic",
      "description": "Make your weekends memorable with a day picnic in Washim. These locations provide an ideal escape from city life, with opportunities for outdoor games, photography, nature walks, and enjoying local food in a peaceful setting."
    },
    {
      "name": "Washim Riverside Picnic Spot",
      "description": "Spend a relaxing day at Washim’s riverside picnic spots, where the calm water, gentle breeze, and natural surroundings create the perfect backdrop for picnics, family outings, and photography. Some locations also offer boating or other light recreational activities."
    },
    {
      "name": "Washim Garden Picnic Spot",
      "description": "Enjoy a refreshing picnic in Washim’s beautiful gardens with well-maintained lawns, flowering plants, and shaded areas. These spots are ideal for leisurely strolls, outdoor meals, and spending quality time in a vibrant and serene environment."
    },
    {
      "name": "Washim Hill Picnic Spot",
      "description": "Plan a hill picnic near Washim to enjoy panoramic views, cool breezes, and a peaceful escape from the hustle of city life. Hilltop spots offer great opportunities for photography, trekking, and enjoying nature in a quiet and scenic setting."
    },
    {
      "name": "Washim Kids Friendly Picnic Spot",
      "description": "Find picnic spots in Washim that cater specifically to children, with playgrounds, open spaces for games, and safe environments. These locations ensure that young ones can play and explore freely while families enjoy a stress-free outing."
    },
    {
      "name": "Washim Scenic Picnic Spot",
      "description": "Capture the beauty of Washim’s scenic picnic spots, featuring rivers, hills, gardens, and natural landscapes. Ideal for photography enthusiasts and those seeking a visually stunning location for a relaxing day out."
    },
    {
      "name": "Washim Outdoor Picnic Spot",
      "description": "Experience the joy of outdoor picnics in Washim with spacious lawns, open-air seating, and recreational facilities. These spots allow visitors to enjoy games, barbecues, and nature while spending quality time with friends and family."
    },
    {
      "name": "Washim Picnic Spot Booking",
      "description": "Easily book your picnic spot in Washim online or in advance to secure a preferred location, especially during weekends or holidays. Booking services often include additional amenities like seating arrangements, food stalls, and guided arrangements for a smooth picnic experience."
    },
    {
      "name": "Washim Picnic Tour Packages",
      "description": "Choose from curated picnic tour packages in Washim that include transport, meal arrangements, guided visits, and organized activities. Perfect for groups, families, or corporate outings, these packages make planning a picnic hassle-free and enjoyable."
    },
    {
      "name": "Washim Best Picnic Location",
      "description": "Discover the best picnic locations in Washim selected for their beauty, accessibility, and facilities. These spots offer the ideal combination of scenic landscapes, comfort, and entertainment to create a memorable day out for everyone."
    }
  ],
  "tableData": [
    ["- Picnic Spot Near Washim", "- Washim Top Picnic Places"],
    ["- Washim Family Picnic Spot", "- Washim Nature Picnic Spot"],
    ["- Affordable Picnic Spot Washim", "- Washim Weekend Picnic"],
    ["- Washim Riverside Picnic Spot", "- Washim Garden Picnic Spot"],
    ["- Washim Hill Picnic Spot", "- Washim Kids Friendly Picnic Spot"],
    ["- Washim Scenic Picnic Spot", "- Washim Outdoor Picnic Spot"],
    ["- Washim Picnic Spot Booking", "- Washim Picnic Tour Packages"],
    ["- Washim Best Picnic Location", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Picnic Spot Near Washim",
    "WhyChoosedescription": "Woodland Escape Resort is an ideal picnic destination near Washim, offering families and groups a refreshing retreat surrounded by nature. With lush greenery, tranquil surroundings, and clean open spaces, it’s the perfect place to relax, reconnect, and spend a joyful day outdoors."
  },
  {
    "WhyChooseheading": "Peaceful Natural Environment",
    "WhyChoosedescription": "Located amidst dense trees and scenic landscapes, Woodland Escape Resort offers an authentic nature experience. The peaceful ambiance, chirping birds, and cool breeze create a serene backdrop, allowing guests to unwind and escape from the fast pace of daily life."
  },
  {
    "WhyChooseheading": "Spacious Picnic Areas & Relaxing Spots",
    "WhyChoosedescription": "The resort features large picnic lawns, shaded sit-outs, and comfortable rest zones where families can enjoy games, laughter, and leisure time. Whether you prefer lounging under the trees or sitting by a pond, every corner of Woodland Escape is designed for relaxation."
  },
  {
    "WhyChooseheading": "Fun Activities for Everyone",
    "WhyChoosedescription": "From nature walks and cycling trails to light adventure games and outdoor sports, Woodland Escape Resort provides a variety of activities to keep visitors entertained. It’s the perfect mix of recreation and relaxation, suitable for all ages."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "Enjoy freshly prepared local and traditional dishes, along with snacks and refreshing beverages. The resort ensures that your picnic is complemented with tasty food options that satisfy every palate, making your day both fun and fulfilling."
  },
  {
    "WhyChooseheading": "Safe and Family-Friendly Ambience",
    "WhyChoosedescription": "Woodland Escape Resort is designed to offer families and groups a safe, clean, and welcoming environment. Parents can relax while children play freely in open spaces, surrounded by the beauty of nature."
  },
  {
    "WhyChooseheading": "Easily Accessible from Washim",
    "WhyChoosedescription": "Located just a short drive from Washim, Woodland Escape Resort is easy to reach yet far enough to feel like a true escape. Its convenient location makes it perfect for a quick day trip or weekend picnic without the stress of long travel."
  }
]





















  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a picnic spot near Washim?",
    answer: "Woodland Escape Resort is one of the best picnic spots near Washim, offering lush green surroundings, open lawns, and a serene environment. It’s perfect for families and friends looking to relax and enjoy a day in nature."
  },
  {
    question: "How far is Woodland Escape Resort from Washim city?",
    answer: "The resort is conveniently located within driving distance from Washim, making it ideal for a day trip or weekend picnic. It’s easily accessible while providing a refreshing escape from the city."
  },
  {
    question: "What activities are available for picnic visitors at Woodland Escape Resort?",
    answer: "Guests can enjoy nature walks, outdoor games, cycling, open lawns, and dedicated kids’ play areas. The resort combines fun and relaxation for visitors of all ages."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups visiting for a picnic?",
    answer: "Absolutely! The resort is family-friendly and group-friendly, offering safe, spacious, and well-maintained areas where everyone can enjoy themselves comfortably."
  },
  {
    question: "Does Woodland Escape Resort provide food and refreshments for picnic guests?",
    answer: "Yes, the resort provides freshly prepared meals, snacks, and beverages. Picnic packages can include lunch and refreshments, ensuring a hassle-free and enjoyable experience."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort near Washim?",
    answer: "You can easily book by calling or sending a WhatsApp message to our reservations team, or by visiting the official website. Advance booking is recommended, especially for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Ramesh & Family, Washim",
    text: "Our picnic at Woodland Escape Resort was wonderful! The kids loved the play areas, the surroundings were beautiful, and the food was delicious. Truly the best picnic spot near Washim!"
  },
  {
    name: "Ms. Kavita & Friends, Washim",
    text: "We had a fantastic day at Woodland Escape Resort! The greenery, open lawns, and peaceful atmosphere made it perfect for a picnic. Highly recommended for anyone near Washim."
  }
];




























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Picnic Spot Near Washim",
  "image": "https://woodlandescape.com/assets/images/washim-picnic-spot.jpg",
  "description": "Enjoy a perfect family picnic near Washim at Woodlandescape Resort. Scenic riverside spots, gardens, hills, and outdoor activities make it ideal for weekend getaways and kids-friendly outings.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "46"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/picnic-spot-washim"
  }
};



  return (
    <div>
<Helmet>
  <title>Picnic Spot Near Washim | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a fun-filled picnic near Washim at Woodlandescape Resort. Ideal for family outings, scenic riverside views, gardens, hilltop spots, and weekend trips." 
  />
  <meta 
    name="keywords" 
    content="Picnic Spot Near Washim, Washim Top Picnic Places, Washim Family Picnic Spot, Washim Nature Picnic Spot, Affordable Picnic Spot Washim, Washim Weekend Picnic, Washim Riverside Picnic Spot, Washim Garden Picnic Spot, Washim Hill Picnic Spot, Washim Kids Friendly Picnic Spot, Washim Scenic Picnic Spot, Washim Outdoor Picnic Spot, Washim Picnic Spot Booking, Washim Picnic Tour Packages, Washim Best Picnic Location" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/40.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Picnicspotnearwashish;